var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavorite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.375L18.729 29.333C18.521 29.4443 18.3163 29.493 18.115 29.479C17.913 29.465 17.7357 29.4027 17.583 29.292C17.4303 29.1807 17.3193 29.0243 17.25 28.823C17.1807 28.6217 17.1737 28.4167 17.229 28.208L18.083 24.542L15.188 22.083C15.0073 21.9443 14.8997 21.7743 14.865 21.573C14.8297 21.3717 14.84 21.1807 14.896 21C14.9513 20.8193 15.0623 20.663 15.229 20.531C15.3957 20.399 15.5833 20.326 15.792 20.312L19.562 19.979L21.062 16.5C21.1593 16.278 21.2913 16.1183 21.458 16.021C21.6247 15.9237 21.8053 15.875 22 15.875C22.1947 15.875 22.3753 15.9237 22.542 16.021C22.7087 16.1183 22.8407 16.278 22.938 16.5L24.438 20L28.208 20.312C28.4167 20.326 28.6043 20.4027 28.771 20.542C28.9377 20.6807 29.0487 20.8403 29.104 21.021C29.16 21.2017 29.167 21.389 29.125 21.583C29.083 21.7777 28.972 21.9443 28.792 22.083L25.917 24.542L26.771 28.208C26.8263 28.4167 26.8193 28.6217 26.75 28.823C26.6807 29.0243 26.5697 29.1807 26.417 29.292C26.2643 29.4027 26.087 29.465 25.885 29.479C25.6837 29.493 25.479 29.4443 25.271 29.333L22 27.375Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavorite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favorite.f4e9ff2239adf935e6415d95c49c1b00.svg";